import styled from 'styled-components'
import { motion } from 'framer-motion'
import { theme } from '../../theme/theme'
import type { TimeSlot as TimeSlotType } from './types'
import { BodySmallMedium } from '../styles/Typography'
import { formatTime } from '../../utils/dates'

interface TimeSlotProps {
  slot: TimeSlotType
  isSelected: boolean
  onClick: () => void
}

export const TimeSlot = ({ slot, isSelected, onClick }: TimeSlotProps) => {
  return (
    <StyledTimeSlot
      onClick={onClick}
      $isSelected={isSelected}
      type="button"
      whileHover={!isSelected ? { y: -1 } : undefined}
      whileTap={{ y: 0 }}
      transition={{ duration: 0.2, ease: 'easeInOut' }}
    >
      <StyledBodySmallMedium>{formatTime(slot.startTime)}</StyledBodySmallMedium>
    </StyledTimeSlot>
  )
}

const StyledTimeSlot = styled(motion.button)<{
  $isSelected: boolean
}>`
  padding: ${theme.spacing.small}px;
  border-radius: ${theme.spacing.small}px;
  border: none;
  cursor: pointer;
  text-align: center;
  min-width: 70px;
  background-color: ${({ $isSelected }) => ($isSelected ? theme.color.plum : theme.color.beigeLight)};
  color: ${({ $isSelected }) => ($isSelected ? theme.color.white : theme.color.black)};

  &:last-child {
    margin-bottom: ${theme.spacing.large}px;
  }

  @media screen and (max-width: ${theme.breakpoint.large}px) {
    min-width: auto;
    width: 100%;
    padding: ${theme.spacing.small}px 2px;
    font-size: ${theme.fontSize.xsmall}px;
  }
`

const StyledBodySmallMedium = styled(BodySmallMedium)`
  @media screen and (max-width: ${theme.breakpoint.large}px) {
    font-size: ${theme.fontSize.xsmall}px;
  }
`
